import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import AnalyticsSectional from '../components/MT_Score/AnalyticsSectional'

const MtScoreAnalyticsSectional = () => {
  return (
    <>
    <Navbar />
    <AnalyticsSectional />
    </>
  )
}

export default MtScoreAnalyticsSectional